export const pluginPermissions = {
  displayPlugin: [{
    action: 'plugin::reports.read',
    subject: null
  }]
};